// @ts-nocheck
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useMediaQuery,
} from "@chakra-ui/react";
import { faMultiply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import useFetch from "../../../ApiClient/GetApi";
import { PostApi } from "../../../ApiClient/PostApi";
import { Loader2 } from "../../loader/Loader";
import { error_toaster, success_toaster } from "../../toaster/Toaster";
import Header from "../layout/Header";
import { BulletList, Facebook } from "react-content-loader";
import { useNavigate } from "react-router-dom";
export default function CardPage() {
  const navigate = useNavigate();
  const [xl] = useMediaQuery("(min-width: 1280px)");
  const [md] = useMediaQuery("(min-width: 768px)");
  const [sm] = useMediaQuery("(min-width: 640px)");
  const [xs] = useMediaQuery("(min-width: 425px)");

  const { data } = useFetch(
    `booking/payment_detail_page/${localStorage.getItem("orderId")}`
  );

  const [card_number, setCardNumber] = useState("");
  const [name, setName] = useState("");
  const [cvc, setCvc] = useState("");
  const [exp_year, set_exp_year] = useState("");
  const [exp_month, set_exp_month] = useState("");
  const [loading, SetLoading] = useState(false);

  const paymentByCard = async () => {
    if (name === "") {
      error_toaster("Card Name is required!");
      return false;
    }
    if (card_number === "") {
      error_toaster("Card No. is required");
      return false;
    }
    if (cvc === "") {
      error_toaster("Security Code is required!");
      return false;
    }

    SetLoading(true);
    const res = await PostApi("users/home/paymentByCard", {
      card_number: card_number,
      name: name,
      exp_year: exp_year,
      exp_month: exp_month,
      amount:
        data?.data?.serviceType === "Full Services"
          ? data?.data?.freightPrice
          : data?.data?.totalPrice,
      cvc: cvc,
      token: localStorage.getItem("paypal_access_token"),
      order_id: localStorage.getItem("orderId"),
    });

    if (res.data.status === "1") {
      success_toaster(res.data.message);
      localStorage.setItem("transactionId", res.data.data.id);
      navigate("/successfull_payment");
    } else {
      SetLoading(false);
      error_toaster(res.data.message);
    }
  };
  const inputStyle =
    "bg-white w-full border-none font-normal sm:text-xl text-lg px-5 py-3 rounded-lg placeholder:text-black placeholder:text-opacity-40 focus:outline-none";
  return (
    <section className="font-soehne">
      <Header />

      <section
        className="xl:w-4/5 w-11/12 bg-themeGray2 mx-auto lg:my-20 my-12 sm:py-12 py-8 sm:px-8 px-4 
              rounded-lg"
      >
        {data.length === 0 ? (
          <Loader2 />
        ) : (
          <>
            {loading ? (
              <Facebook height={160} />
            ) : (
              <div className="grid lg:grid-cols-12 gap-x-10 gap-y-12">
                <div className="lg:col-span-7 space-y-8">
                  <div className="flex items-center gap-x-3">
                    <img
                      src="images/myOrders/card.webp"
                      alt="card"
                      className="w-6"
                    />
                    <h1 className="font-medium text-2xl text-themeBlue">
                      Enter Your Card Details
                    </h1>
                  </div>
                  <div className="space-y-4">
                    <div>
                      <input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className={inputStyle}
                        placeholder="Name on Card"
                      />
                    </div>
                    <div>
                      <input
                        value={card_number}
                        maxLength={16}
                        onChange={(e) => setCardNumber(e.target.value)}
                        className={inputStyle}
                        placeholder="Card Number"
                      />
                    </div>
                    <div>
                      <input
                        maxLength={3}
                        value={cvc}
                        onChange={(e) => setCvc(e.target.value)}
                        className={inputStyle}
                        placeholder="Security Code"
                      />
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                      <div>
                        <select
                          defaultValue={exp_year}
                          onChange={(e) => set_exp_year(e.target.value)}
                          className={inputStyle}
                        >
                          <option>Select Year</option>
                          <option value="2023">2023</option>
                          <option value="2024">2024</option>
                          <option value="2025">2025</option>
                          <option value="2026">2026</option>
                          <option value="2027">2027</option>
                          <option value="2028">2028</option>
                          <option value="2029">2029</option>
                          <option value="2030">2030</option>
                          <option value="2031">2031</option>
                          <option value="2032">2032</option>
                          <option value="2033">2033</option>
                          <option value="2034">2034</option>
                          <option value="2035">2035</option>
                        </select>
                      </div>
                      <div>
                        <select
                          defaultValue={exp_month}
                          onChange={(e) => set_exp_month(e.target.value)}
                          className={inputStyle}
                        >
                          <option>Select Month</option>
                          <option value="01">01</option>
                          <option value="02">02</option>
                          <option value="03">03</option>
                          <option value="04">04</option>
                          <option value="05">05</option>
                          <option value="06">06</option>
                          <option value="07">07</option>
                          <option value="08">08</option>
                          <option value="09">09</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                        </select>
                      </div>
                    </div>
                    <div className="flex justify-end">
                      <button
                        onClick={paymentByCard}
                        className="flex items-center gap-x-3 bg-themeBlue text-white font-normal text-base px-8 py-3 
                rounded-xl"
                      >
                        <img
                          src="images/myOrders/paypal.webp"
                          alt="paypal"
                          className="w-8"
                        />
                        <span>{`Pay  $${
                          data?.data?.serviceType === "Full Services"
                            ? data?.data?.freightPrice
                            : data?.data?.totalPrice
                        }`}</span>
                      </button>
                    </div>
                  </div>
                  <div>
                    {/* <div className="grid sm:grid-cols-2 gap-x-7 gap-y-4">
                    <input
                      type="number"
                      name="cardNo"
                      placeholder="XXXX XXXX XXXX XXXX"
                      className={`${inputStyle} sm:col-span-2`}
                    />
                    <input
                      type="number"
                      name="expiry"
                      placeholder="Expiry"
                      className={inputStyle}
                    />
                    <input
                      type="number"
                      name="cvv"
                      placeholder="CVV"
                      className={inputStyle}
                    />
                  </div> */}
                  </div>
                </div>
                <div className="lg:col-span-5 sm:space-y-6 space-y-4">
                  <div className="flex lg:justify-center items-center gap-x-3">
                    <img
                      src="images/myOrders/invoice.webp"
                      alt="card"
                      className="w-6"
                    />
                    <h1 className="font-medium text-2xl text-themeBlue">
                      Invoice Details
                    </h1>
                  </div>
                  <ul className="space-y-6">
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Insurance
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.insurance}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Freight ( kg * {data?.data?.companyTax})
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.freighPrice}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Repacking Fee
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.repacking}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Import VAT
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.vatTax ?? ""}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Import Duties
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.importDuty ?? ""}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Customs Clearance Fee
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.customerClearanceFee ?? ""}
                      </h5>
                    </li>
                  </ul>
                  <h1 className="font-medium sm:text-4xl text-2xl text-end">
                    Total Price : $ {data?.data?.totalPrice ?? ""}
                  </h1>
                  <h1 className="font-medium sm:text-4xl text-2xl text-end">
                    {data?.data?.serviceType === "Full Services" ? (
                      <div>
                        {" "}
                        <span className="text-sm font-normal mx-4">
                          For Full Services only to pay( Freight + Insurance)
                        </span>
                        <br />$ {data?.data?.freightPrice}
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </h1>
                  {/* <div className="flex justify-end">
                <button
                  onClick={openModal}
                  className="font-bold sm:text-xl text-base text-white bg-themeBlue px-6 py-3 rounded-md
                  border border-themeBlue hover:bg-transparent hover:text-themeBlue"
                >
                  Secure Pay
                </button>
              </div> */}
                </div>
              </div>
            )}
          </>
        )}
      </section>
    </section>
  );
}
